"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenResolver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEAS",
                name: "eas",
                type: "address",
            },
            {
                internalType: "contract IERC20",
                name: "targetToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "targetAmount",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AccessDenied",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidEAS",
        type: "error",
    },
    {
        inputs: [],
        name: "NotPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "attest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "isPayable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiAttest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiRevoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "revoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TokenResolver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(eas, targetToken, targetAmount, overrides) {
        return super.deploy(eas, targetToken, targetAmount, overrides || {});
    }
    getDeployTransaction(eas, targetToken, targetAmount, overrides) {
        return super.getDeployTransaction(eas, targetToken, targetAmount, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TokenResolver__factory = TokenResolver__factory;
//# sourceMappingURL=TokenResolver__factory.js.map